import React, { useState, useEffect, useRef } from "react";
import { Redirect, Route, Link, useHistory } from "react-router-dom";
import api from "services/api";
import { Accordion } from "react-bootstrap";
import Translator, { __ } from "services/Translator";

function SeoSection(props) {
  const history = useHistory();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleContent = () => {
    setIsExpanded((prevState) => !prevState);
    // alert(isExpanded);
  };
  return (
    <>
      <div className={"promotions_area "}>
        <div
          className={
            "seo-content-area " + (isExpanded ? "showFull" : "showHalf")
          }
        >
          <div className={"promotions_item_area seo_items "}>
            <article className="single_promotion blackBtnBG">
              <div className="promotion_content_area">
                <p className="promotion_title">
                  Winnabull - The Ultimate Social Casino & Entertainment Hub
                </p>
                <p className="promotion_description">
                  Winnabull leads the way in the social casino and entertainment
                  industry, offering a trusted and dynamic platform for players
                  in the USA. Focused on fun, safety, and accessibility,
                  Winnabull delivers a gaming experience that's second to none.
                </p>
              </div>
            </article>
            <article className="single_promotion blackBtnBG">
              <div className="promotion_content_area">
                <p className="promotion_title">About the Winnabull Platform</p>
                <p className="promotion_description">
                  Since its inception, Winnabull has become a go-to destination
                  for social gaming enthusiasts across the United States. Our
                  platform features a broad range of games, creating a relaxed
                  yet thrilling environment for players. With a focus on
                  security and enjoyment, Winnabull is your top choice for safe
                  and rewarding entertainment. All for free without any purchase
                  needed to be able to enjoy the best in social casino
                  entertainment.
                </p>
              </div>
            </article>
            <article className="single_promotion blackBtnBG">
              <div className="promotion_content_area">
                <p className="promotion_title">
                  Games & Features for Every Player
                </p>
                <p className="promotion_description">
                  Winnabull offers a massive selection of games to cater to all
                  types of players. From timeless favorites like slots, scratch
                  card games, blackjack, roulette, and baccarat to a variety of
                  engaging table games, there's something for everyone. For
                  those craving an authentic casino experience, our live dealer
                  games bring the thrill of real-time action with professional
                  dealers streamed directly to your device. <br />
                  And don't miss our <b>Weekly Top Picks</b>, where we highlight
                  trending games, the hottest providers, and the biggest wins to
                  keep you in the loop on what's popular!
                </p>
              </div>
            </article>
            <article className="single_promotion blackBtnBG">
              <div className="promotion_content_area">
                <p className="promotion_title">
                  Explore the Best in Social Gaming
                </p>
                <p className="promotion_description">
                  At Winnabull, we go beyond the basics to keep the excitement
                  alive. Check out our <b>Game Spotlights</b>, where we showcase
                  fan favorites, trending titles, and newly added games. Whether
                  you're into fast-paced action or strategic gameplay, you'll
                  always find something fresh and exciting
                </p>
              </div>
            </article>
            <article className="single_promotion blackBtnBG">
              <div className="promotion_content_area">
                <p className="promotion_title">Top-Tier Game Providers</p>
                <p className="promotion_description">
                  Winnabull partners with industry-leading providers such as
                  Pragmatic Play, Betsoft, Habanero, Bgaming and Spinomenal to
                  deliver high-quality games with immersive visuals and seamless
                  gameplay. The best games out there to play and win big prizes
                  with.
                </p>
              </div>
            </article>
            <article className="single_promotion blackBtnBG">
              <div className="promotion_content_area">
                <p className="promotion_title">
                  Your Gateway to Fun & Entertainment
                </p>
                <p className="promotion_description">
                  At Winnabull, we prioritize your enjoyment. Our platform is
                  designed to offer engaging gameplay, exciting casino
                  promotions, and diverse game options to suit every taste. Easy
                  to use and optimized for seamless performance, Winnabull
                  provides a safe, secure, and thoroughly entertaining social
                  casino experience.
                </p>
              </div>
            </article>
          </div>
        </div>

        <br />

        <center>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            onClick={toggleContent}
            className="commonBtn primaryBtn"
          >
            <span className="front">
              {isExpanded ? "Show Less" : "Show More"}
            </span>
          </Link>
        </center>
      </div>
    </>
  );
}

export default SeoSection;
